import Constant from '@/const';
import axios from 'axios';

const getPharmacyHandover = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/pharmacy/handover/`),
      { params },
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export default getPharmacyHandover;
